import { LinkProps } from 'next/link';
import { checkWindow } from './check-window';
import { getFromLocalStorageByKey } from './localStorage';

export const checkIsApp = (): boolean => {
  if (!checkWindow()) return false;
  const appSession = getFromLocalStorageByKey('appSession');
  const queryString = new URLSearchParams(window?.location?.search);
  return !!appSession || !!queryString.get('app') || !!localStorage.getItem('isApp');
};

export const execute = (name: string, params: Record<string, any>, callback: string | null) => {
  /**
   * Checks if a value matches a specific constructor type.
   * @param {Function} type - The constructor type to match against.
   * @param {*} val - The value to check.
   * @returns {boolean} - True if the value is not undefined or null and matches the provided constructor type, otherwise false.
   */
  const is = (type: ArrayConstructor | ObjectConstructor, val: any) =>
    ![undefined, null].includes(val) && val.constructor === type;

  /**
   * Serializes an object into a URL-encoded query string.
   * @param {Object} params - The object containing key-value pairs to be serialized.
   * @returns {string} - A URL-encoded query string representing the input object.
   */
  const serialize = (p: Record<string, any>) =>
    Object.keys(p)
      .map((key) => {
        let item = p[key];

        if (is(Array, item) || is(Object, item)) {
          item = JSON.stringify(item);
        }

        return `${key}=${encodeURIComponent(item)}`;
      })
      .join('&');

  (
    window as Window &
      typeof globalThis & {
        BWB_JS: any;
      }
  )?.BWB_JS?.execute(name, params ? serialize(params) : null, callback);
};

export const openInBrowser = (url: LinkProps['href']) => {
  execute('openInBrowser', { url }, null);
};

export const setBackButtonUrl = (url: LinkProps['href']) => {
  execute('setBackButtonUrl', { url }, null);
};

export const closeOverlay = () => {
  execute('closeOverlay', null, null);
};

export const downloadPdf = (obj: any) => {
  execute(
    'downloadPdf',
    {
      params: {
        document: obj,
        fileName: 'file.pdf',
      },
    },
    null
  );
};

